module.exports = __webpack_public_path__ + "img/esg-E.1a5fda31.svg";